import { isMobile } from './isMobile';
import { dataLayer } from 'globals/datalayerPusher';

let isFading = false;

// Reading aid text preview
function initReadingAid(heightFunction = null, initialHeightOnLoad = null) {
    const readingAid = document.querySelectorAll('[data-readingaid]');
    if (readingAid.length > 0) {
        readingAid.forEach(readingAidContainer => {
            if ((readingAidContainer.dataset.readingaid === 'desktop' && !isMobile()) ||
                (readingAidContainer.dataset.readingaid === 'mobile' && isMobile()) ||
                readingAidContainer.dataset.readingaid === '') {
                const content = readingAidContainer.querySelector('[data-readingaid-text]');
                const toggle = readingAidContainer.querySelector('[data-readingaid-toggle]');
                const gradient = readingAidContainer.querySelector('[data-readingaid-gradient]');
                if (gradient) {
                    gradient.classList.add('readingAid__gradient--invisible');
                    if (content && toggle) {
                        let contentScrollheight = content.scrollHeight ? content.scrollHeight : 0;
                        let maxHeight = 294;
                        if (heightFunction && typeof heightFunction === 'function') {
                            maxHeight = heightFunction(readingAidContainer);
                        } else if (readingAidContainer.dataset.readingaidHeight) {
                            maxHeight = JSON.parse(readingAidContainer.dataset.readingaidHeight);
                        }
                        if (typeof maxHeight === 'object') {
                            maxHeight = isMobile() ? maxHeight.mobile : maxHeight.desktop;
                        }
                        toggle.classList.add('readingAid__expand--invisible');
                        toggle.setAttribute('tabindex', '-1');
                        if (contentScrollheight > maxHeight) {
                            const contentId = content.getAttribute('id');
                            if (contentId) {
                                toggle.setAttribute('aria-controls', contentId);
                            }
                            toggleClasses(false, toggle, content, gradient, maxHeight, maxHeight);
                            toggle.addEventListener('click', () => {
                                if (!isFading) {
                                    // setting the contentScrollheight again for when the container height changed before clicking
                                    contentScrollheight = content.scrollHeight;
                                    const fadeIn = !content.classList.contains('readingAid__text--expanded');
                                    toggleClasses(fadeIn, toggle, content, gradient, contentScrollheight, maxHeight);
                                    toggleButtonText(toggle);
                                    if (initialHeightOnLoad === true) {
                                        content.classList.remove('readingAid__text--height');
                                    }
                                }
                            });
                            toggle.classList.remove('readingAid__expand--invisible');
                            toggle.removeAttribute('aria-hidden');
                            toggle.removeAttribute('tabindex');
                            readingAidContainer.removeAttribute('data-readingaid');
                        }
                    }
                }
            }
        });
    }
}

function toggleClasses(fadeIn, button, content, gradient, contentScrollheight, maxHeight) {
    if (fadeIn) {
        dataLayer.pushInteraction('stat_content_readmore', 'expand');
        isFading = true;
        button.setAttribute('aria-expanded', true);
        content.classList.add('readingAid__text--expanded');
        content.style.maxHeight = `${ contentScrollheight }px`;
        gradient.classList.add('readingAid__gradient--invisible');
        setTimeout(() => {
            content.style.removeProperty('max-height');
            isFading = false;
        }, 500);
    } else {
        isFading = true;
        content.style.maxHeight = `${ contentScrollheight }px`;
        setTimeout(() => {
            button.setAttribute('aria-expanded', false);
            content.classList.remove('readingAid__text--expanded');
            content.style.maxHeight = `${ maxHeight }px`;
            gradient.classList.remove('readingAid__gradient--invisible');
            isFading = false;
        }, 50);
    }
}

function toggleButtonText(button) {
    const showText = button.innerHTML;
    const hideText = button.dataset.readingaidToggle;
    if (showText && hideText) {
        button.innerHTML = hideText;
        button.dataset.readingaidToggle = showText;
    }
}

export { initReadingAid };
